// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as SlabDataVm from "./SlabDataVm.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CurrencyMinor from "../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as CorePricingUtils from "../library/utils/CorePricingUtils.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ModificationStatusVm from "./ModificationStatusVm.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function mapIntegerToDelta(value) {
  if (value === 0) {
    return ;
  } else {
    return value;
  }
}

function mapPaisaToDeltaRupee(value) {
  if (CurrencyMinor.fromBase(value) === 0) {
    return ;
  } else {
    return Caml_option.some(CurrencyMajorMinorMapper.baseToCurrency(value));
  }
}

function mapZonesToId(zones, zone_ids) {
  return List.map((function (z) {
                return z.description;
              }), List.filter(function (z) {
                    return List.exists((function (i) {
                                  return i === z.id;
                                }), zone_ids);
                  })(zones));
}

function mapClustersToId(clusters, cluster_ids) {
  return List.map((function (c) {
                return c.description;
              }), List.filter(function (c) {
                    return List.exists((function (i) {
                                  return i === c.id;
                                }), cluster_ids);
                  })(clusters));
}

function serializedBaseDetails(core_pricing, delta_details) {
  return {
          base_fare: {
            delta: mapPaisaToDeltaRupee(delta_details.base_fare_delta),
            value: Currency.add(core_pricing.base_fare, CurrencyMajorMinorMapper.baseToCurrency(delta_details.base_fare_delta))
          },
          free_duration: {
            delta: mapIntegerToDelta(CorePricingUtils.fromMilliSecToMins(delta_details.free_duration_delta)),
            value: core_pricing.free_duration + CorePricingUtils.fromMilliSecToMins(delta_details.free_duration_delta) | 0
          },
          waiting_rate: {
            delta: mapPaisaToDeltaRupee(delta_details.waiting_rate_per_min_delta),
            value: Currency.add(core_pricing.waiting_rate, CurrencyMajorMinorMapper.baseToCurrency(delta_details.waiting_rate_per_min_delta))
          },
          free_kms: {
            delta: mapIntegerToDelta(delta_details.free_kms_delta),
            value: core_pricing.free_kms + delta_details.free_kms_delta | 0
          },
          free_km_price_per_min: {
            delta: mapPaisaToDeltaRupee(delta_details.free_km_price_per_min_delta),
            value: Currency.add(core_pricing.free_km_price_per_min, CurrencyMajorMinorMapper.baseToCurrency(delta_details.free_km_price_per_min_delta))
          }
        };
}

function getRepeatDaysString(days) {
  if (days !== undefined && List.length(days) !== 7) {
    return ListUtils$Catalyst.toString(days, (function (a) {
                  return $$String.sub(a, 0, 3);
                }), undefined, undefined);
  } else {
    return "All";
  }
}

function serializeZoneAndClusterData(descriptions) {
  if (!descriptions) {
    return {
            content: "Not Applicable",
            tool_tip_content: undefined
          };
  }
  var match = descriptions.tl;
  var a = descriptions.hd;
  if (!match) {
    return {
            content: a,
            tool_tip_content: undefined
          };
  }
  var tail = match.tl;
  var b = match.hd;
  if (tail) {
    return {
            content: a + (", " + (b + ", ")),
            tool_tip_content: {
              content: ListUtils$Catalyst.toString(tail, (function (a) {
                      return a;
                    }), undefined, undefined),
              title: "+" + (String(List.length(tail)) + " more")
            }
          };
  } else {
    return {
            content: a + (", " + b),
            tool_tip_content: undefined
          };
  }
}

function serializeEligibilityRules(eligibility_rules, zones, clusters) {
  var z = eligibility_rules.pick_up_zone;
  var c = eligibility_rules.pick_up_cluster;
  var z$1 = eligibility_rules.drop_zone;
  var c$1 = eligibility_rules.drop_cluster;
  return {
          start_time: eligibility_rules.start_time,
          end_time: eligibility_rules.end_time,
          repeat_days: getRepeatDaysString(eligibility_rules.repeat_days),
          pick_up_zone: z !== undefined ? serializeZoneAndClusterData(mapZonesToId(zones, z)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          pick_up_cluster: c !== undefined ? serializeZoneAndClusterData(mapClustersToId(clusters, c)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          drop_zone: z$1 !== undefined ? serializeZoneAndClusterData(mapZonesToId(zones, z$1)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              }),
          drop_cluster: c$1 !== undefined ? serializeZoneAndClusterData(mapClustersToId(clusters, c$1)) : ({
                content: "Not Applicable",
                tool_tip_content: undefined
              })
        };
}

function getVm(core_pricing, modifications, zones, clusters) {
  var modifications_map = {};
  List.iter((function (modification) {
          if (modification.TAG === /* AB */0) {
            var test_control_details = modification.test_control_details;
            var key_details = modification.key_details;
            var status = ModificationStatusVm.getStatus(key_details.status, key_details.start_date);
            var approverInfo = key_details.approver_info;
            var approverInfo$1 = key_details.approver_info;
            var control_slab = Belt_List.get(test_control_details, 0).control_details;
            modifications_map[key_details.external_id] = {
              external_id: key_details.external_id,
              name: key_details.name,
              vehicle_name: core_pricing.vehicle_name,
              region: core_pricing.region_name,
              status: status,
              created_on: Timestamp$Catalyst.toString(key_details.creation_info.creation_time, "DD/MM/yyyy"),
              created_by: key_details.creation_info.first_name + (" " + key_details.creation_info.last_name),
              approved_on: approverInfo !== undefined ? Timestamp$Catalyst.toString(approverInfo.approved_on, "DD/MM/yyyy") : "N/A",
              approved_by: approverInfo$1 !== undefined ? approverInfo$1.first_name + (" " + approverInfo$1.last_name) : "N/A",
              core_pricing_name: core_pricing.campaign_name,
              start_date: key_details.start_date,
              end_date: key_details.end_date,
              base_details: {
                TAG: /* AB */0,
                control_details: serializedBaseDetails(core_pricing, Belt_List.get(test_control_details, 0).control_details.base_details),
                test_detail_and_ids: List.map((function (modification) {
                        return {
                                test_details: serializedBaseDetails(core_pricing, modification.test_details.base_details),
                                test_ids: modification.test_ids
                              };
                      }), test_control_details)
              },
              slabs: {
                TAG: /* AB */0,
                control_details: SlabDataVm.getVm(core_pricing.free_kms + control_slab.base_details.free_kms_delta | 0, control_slab.slab_details),
                test_slab_and_ids: List.map((function (modification) {
                        return {
                                test_details: SlabDataVm.getVm(core_pricing.free_kms + modification.test_details.base_details.free_kms_delta | 0, modification.test_details.slab_details),
                                test_ids: modification.test_ids
                              };
                      }), test_control_details)
              },
              eligibility_rules: serializeEligibilityRules(modification.eligibility_rules, zones, clusters)
            };
            return ;
          }
          var control_details = modification.control_details;
          var key_details$1 = modification.key_details;
          var status$1 = ModificationStatusVm.getStatus(key_details$1.status, key_details$1.start_date);
          var approverInfo$2 = key_details$1.approver_info;
          var approverInfo$3 = key_details$1.approver_info;
          modifications_map[key_details$1.external_id] = {
            external_id: key_details$1.external_id,
            name: key_details$1.name,
            vehicle_name: core_pricing.vehicle_name,
            region: core_pricing.region_name,
            status: status$1,
            created_on: Timestamp$Catalyst.toString(key_details$1.creation_info.creation_time, "DD/MM/yyyy"),
            created_by: key_details$1.creation_info.first_name + (" " + key_details$1.creation_info.last_name),
            approved_on: approverInfo$2 !== undefined ? Timestamp$Catalyst.toString(approverInfo$2.approved_on, "DD/MM/yyyy") : "N/A",
            approved_by: approverInfo$3 !== undefined ? approverInfo$3.first_name + (" " + approverInfo$3.last_name) : "N/A",
            core_pricing_name: core_pricing.campaign_name,
            start_date: key_details$1.start_date,
            end_date: key_details$1.end_date,
            base_details: {
              TAG: /* Simple */1,
              _0: serializedBaseDetails(core_pricing, control_details.base_details)
            },
            slabs: {
              TAG: /* Simple */1,
              _0: SlabDataVm.getVm(core_pricing.free_kms + control_details.base_details.free_kms_delta | 0, control_details.slab_details)
            },
            eligibility_rules: serializeEligibilityRules(modification.eligibility_rules, zones, clusters)
          };
          
        }), modifications);
  return modifications_map;
}

export {
  mapIntegerToDelta ,
  mapPaisaToDeltaRupee ,
  mapZonesToId ,
  mapClustersToId ,
  serializedBaseDetails ,
  getRepeatDaysString ,
  serializeZoneAndClusterData ,
  serializeEligibilityRules ,
  getVm ,
  
}
/* CorePricingUtils Not a pure module */
